<template>
  <div>

    <!-- ── Stat Tiles ──────────────────────────────────────────── -->
    <div class="row mb-2 stat-tiles">

      <div class="col-lg-4 col-md-6 mb-4">
        <router-link :to="{ path: '/view-clients-agency' }" class="text-decoration-none">
          <div class="card border-0 shadow-sm h-100">
            <div class="card-body py-3 px-4 d-flex align-items-center" style="gap: 14px;">
              <div>
                <p class="mb-0 text-muted" style="font-size: .72rem; text-transform: uppercase; letter-spacing: .04em;">Basic Healthcare Provision Fund</p>
                <h4 class="mb-0 font-weight-bold text-dark">{{ informaldata.bhcpf | numeral(0, 0) }}</h4>
              </div>
            </div>
          </div>
        </router-link>
      </div>

      <div class="col-lg-4 col-md-6 mb-4">
        <router-link :to="{ path: '/view-clients-agency' }" class="text-decoration-none">
          <div class="card border-0 shadow-sm h-100">
            <div class="card-body py-3 px-4 d-flex align-items-center" style="gap: 14px;">
              <div class="avatar avatar-md flex-shrink-0">
                <div class="avatar-title bg-soft-dark rounded-circle text-dark">
                  <i class="fe fe-users"></i>
                </div>
              </div>
              <div>
                <p class="mb-0 text-muted" style="font-size: .72rem; text-transform: uppercase; letter-spacing: .04em;">State Equity Program</p>
                <h4 class="mb-0 font-weight-bold text-dark">{{ (informaldata.sep - informaldata.vul_state_pensioners - informaldata.vul_lga_pensioners) | numeral(0, 0) }}</h4>
              </div>
            </div>
          </div>
        </router-link>
      </div>

      <div class="col-lg-4 col-md-6 mb-4">
        <router-link :to="{ path: '/view-clients-agency' }" class="text-decoration-none">
          <div class="card border-0 shadow-sm h-100">
            <div class="card-body py-3 px-4 d-flex align-items-center" style="gap: 14px;">
              <div class="avatar avatar-md flex-shrink-0">
                <div class="avatar-title bg-soft-info rounded-circle text-info">
                  <i class="fe fe-users"></i>
                </div>
              </div>
              <div>
                <p class="mb-0 text-muted" style="font-size: .72rem; text-transform: uppercase; letter-spacing: .04em;">State Equity Program (State Pensioners)</p>
                <h4 class="mb-0 font-weight-bold text-dark">{{ informaldata.vul_state_pensioners | numeral(0, 0) }}</h4>
              </div>
            </div>
          </div>
        </router-link>
      </div>

      <div class="col-lg-4 col-md-6 mb-4">
        <router-link :to="{ path: '/view-clients-agency' }" class="text-decoration-none">
          <div class="card border-0 shadow-sm h-100">
            <div class="card-body py-3 px-4 d-flex align-items-center" style="gap: 14px;">
              <div class="avatar avatar-md flex-shrink-0">
                <div class="avatar-title bg-soft-info rounded-circle text-info">
                  <i class="fe fe-users"></i>
                </div>
              </div>
              <div>
                <p class="mb-0 text-muted" style="font-size: .72rem; text-transform: uppercase; letter-spacing: .04em;">State Equity Program (LGA Pensioners)</p>
                <h4 class="mb-0 font-weight-bold text-dark">{{ informaldata.vul_lga_pensioners | numeral(0, 0) }}</h4>
              </div>
            </div>
          </div>
        </router-link>
      </div>

      <div class="col-lg-4 col-md-6 mb-4">
        <router-link :to="{ path: '/plans' }" class="text-decoration-none">
          <div class="card border-0 shadow-sm h-100">
            <div class="card-body py-3 px-4 d-flex align-items-center" style="gap: 14px;">
              <div class="avatar avatar-md flex-shrink-0">
                <div class="avatar-title bg-soft-secondary rounded-circle text-secondary">
                  <i class="fe fe-users"></i>
                </div>
              </div>
              <div>
                <p class="mb-0 text-muted" style="font-size: .72rem; text-transform: uppercase; letter-spacing: .04em;">Voluntary Contributor</p>
                <h4 class="mb-0 font-weight-bold text-dark">{{ informaldata.voluntary | numeral(0, 0) }}</h4>
              </div>
            </div>
          </div>
        </router-link>
      </div>

      <div class="col-lg-3 col-md-6 mb-4">
        <router-link :to="{ path: '/my-providers' }" class="text-decoration-none">
          <div class="card border-0 shadow-sm h-100">
            <div class="card-body py-3 px-4 d-flex align-items-center" style="gap: 14px;">
              <div class="avatar avatar-md flex-shrink-0">
                <div class="avatar-title bg-soft-info rounded-circle text-info">
                  <i class="fe fe-activity"></i>
                </div>
              </div>
              <div>
                <p class="mb-0 text-muted" style="font-size: .72rem; text-transform: uppercase; letter-spacing: .04em;">Health Facilities</p>
                <h4 class="mb-0 font-weight-bold text-dark">{{ informaldata.providers }}</h4>
              </div>
            </div>
          </div>
        </router-link>
      </div>

      <div class="col-lg-3 col-md-6 mb-4">
        <router-link :to="{ path: '/all-claims' }" class="text-decoration-none">
          <div class="card border-0 shadow-sm h-100">
            <div class="card-body py-3 px-4 d-flex align-items-center" style="gap: 14px;">
              <div class="avatar avatar-md flex-shrink-0">
                <div class="avatar-title bg-soft-warning rounded-circle text-warning">
                  <i class="fe fe-credit-card"></i>
                </div>
              </div>
              <div>
                <p class="mb-0 text-muted" style="font-size: .72rem; text-transform: uppercase; letter-spacing: .04em;">Claims</p>
                <h4 class="mb-0 font-weight-bold text-dark">{{ informaldata.claims | numeral(0, 0) }}</h4>
              </div>
            </div>
          </div>
        </router-link>
      </div>

      <div class="col-lg-3 col-md-6 mb-4">
        <router-link :to="{ path: '/list-records' }" class="text-decoration-none">
          <div class="card border-0 shadow-sm h-100">
            <div class="card-body py-3 px-4 d-flex align-items-center" style="gap: 14px;">
              <div class="avatar avatar-md flex-shrink-0">
                <div class="avatar-title bg-soft-success rounded-circle text-success">
                  <i class="fe fe-file-plus"></i>
                </div>
              </div>
              <div>
                <p class="mb-0 text-muted" style="font-size: .72rem; text-transform: uppercase; letter-spacing: .04em;">All Encounters</p>
                <h4 class="mb-0 font-weight-bold text-dark">{{ informaldata.encounters | numeral(0, 0) }}</h4>
              </div>
            </div>
          </div>
        </router-link>
      </div>

      <div class="col-lg-3 col-md-6 mb-4">
        <router-link :to="{ path: '/view-clients-agency' }" class="text-decoration-none">
          <div class="card border-0 shadow-sm h-100" style="border-left: 3px solid #2563eb !important;">
            <div class="card-body py-3 px-4 d-flex align-items-center" style="gap: 14px;">
              <div class="avatar avatar-md flex-shrink-0">
                <div class="avatar-title bg-soft-primary rounded-circle text-primary">
                  <i class="fe fe-users"></i>
                </div>
              </div>
              <div>
                <p class="mb-0 text-muted" style="font-size: .72rem; text-transform: uppercase; letter-spacing: .04em;">Total Informal Enrollees</p>
                <h4 class="mb-0 font-weight-bold text-primary">
                  {{ informaldata.bhcpf + informaldata.sep + informaldata.voluntary | numeral(0, 0) }}
                </h4>
              </div>
            </div>
          </div>
        </router-link>
      </div>

    </div>

    <!-- ── Quick Links ────────────────────────────────────────────── -->
    <div class="d-flex mb-4" style="gap: 8px;">
      <router-link to="export-date">
        <button class="btn btn-sm btn-outline-secondary">
          <i class="fe fe-calendar mr-1"></i> Filter Enrollee Date
        </button>
      </router-link>
      <router-link to="export-provider">
        <button class="btn btn-sm btn-outline-secondary">
          <i class="fe fe-filter mr-1"></i> Filter Enrollee Provider
        </button>
      </router-link>
    </div>

    <!-- ── Charts ─────────────────────────────────────────────────── -->
    <div class="mb-4">
      <informalLga />
    </div>

    <div class="card shadow table-card mb-4">
      <div class="d-flex align-items-center px-4 pt-4 pb-3">
        <i class="fe fe-bar-chart-2 text-primary mr-2"></i>
        <h6 class="mb-0 font-weight-bold">Gender Distribution by LGA</h6>
      </div>
      <div class="card-body pt-0">
        <GenderbyLGA :sectors="sectors" />
      </div>
    </div>

    <div class="card shadow table-card mb-4">
      <div class="d-flex align-items-center px-4 pt-4 pb-3">
        <i class="fe fe-users text-primary mr-2"></i>
        <h6 class="mb-0 font-weight-bold">Enrollee Distribution by Vulnerable Group</h6>
      </div>
      <div class="card-body pt-0">
        <VulnerableByLGA />
      </div>
    </div>

    <div class="card shadow table-card mb-4">
      <div class="d-flex align-items-center px-4 pt-4 pb-3">
        <i class="fe fe-map-pin text-primary mr-2"></i>
        <h6 class="mb-0 font-weight-bold">Enrollee Distribution by LGA and Facility</h6>
      </div>
      <div class="card-body pt-0">
        <EnrolleebyLGAandFacility />
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-md-6">
        <ChartAboveAndBelow18 />
      </div>
    </div>

    <h6 class="font-weight-bold mb-3">
      <i class="fe fe-activity text-primary mr-2"></i> Category of Vulnerable Group Data
    </h6>
    <div class="row mb-4">
      <div class="col-md-6 mb-4">
        <BasicCategory />
      </div>
      <div class="col-md-6 mb-4">
        <genderCategory />
      </div>
    </div>

  </div>
</template>

<script>
import InformalLga from "./informallga";
import BasicCategory from "./basicCategory";
import GenderbyLGA from "./GenderbyLGA";
import VulnerableByLGA from "./VulnerableByLGA";
// import genderCategoryInformal from "./genderCategoryInformal";
import EnrolleebyLGAandFacility from "./EnrolleebyLGAandFacility";
import ChartAboveAndBelow18 from "./ChartAboveAndBelow18";
import genderCategory from "./genderCategory";

export default {
  components: {
    GenderbyLGA,
    // genderCategoryInformal,
    InformalLga,
    BasicCategory,
    genderCategory,
    VulnerableByLGA,
    EnrolleebyLGAandFacility,
    ChartAboveAndBelow18,
  },

  data() {
    return {
      user: null,
      mydata: "",
      informaldata: "",
      auth_user: "",
      providers: "",
      sectors: [
        {
          name: "Basic Healthcare Provision Fund",
        },
        {
          name: "State Equity Program",
        },
      ],
      clients: "",
      total_clients: "",
      offlineclients: [],
      employees: "",
      plans: "",
      tpas: "",
    };
  },
  beforeMount() {
    this.$batchGet("/api/v1/auth/getinformalsectorenrollees/90")
      .then((response) => {
        this.informaldata = response.data;
        console.log(response);
      })
      .catch((error) => {
        console.error(error);
      });
  },
  computed: {},

  methods: {},
  created() {},
};
</script>
